/* eslint-disable import/no-extraneous-dependencies */
import {getPath} from '@epic-core/common';
import {matchPath} from 'react-router';
import qs from 'query-string'; // eslint-disable-line import/no-extraneous-dependencies

export const getProductMatchParams = pathname => {
    // Ongoing discussion with react router v4 on scoping of route params
    //   https://github.com/supasate/connected-react-router/issues/97
    const productMatch =
        matchPath(pathname, {
            path: `${getPath()}:locale/product/:productName/:productSlug`
        }) ||
        matchPath(pathname, {
            path: `${getPath()}:locale/product/:productName`
        });
    return (productMatch && productMatch.params) || {};
};

export const getCollectionMatchParams = pathname => {
    const productMatch = matchPath(pathname, {
        path: `${getPath()}:locale/collection/:productName`
    });
    return (productMatch && productMatch.params) || {};
};

export const getQueryFromQS = str => {
    const qsArgs = qs.parse(str);
    const {q} = qsArgs;
    return q;
};

export const stripSlug = url => {
    const urlList = url.split('/');
    urlList.pop();
    return urlList.join('/');
};
